import React from "react";

// Shared layout for legal pages (Privacy, Terms) so they stay consistent.
export default function LegalLayout({
  eyebrow,
  title,
  lastUpdated,
  intro,
  sections,
  testId,
}) {
  return (
    <main
      data-testid={testId}
      className="pt-32 pb-20 max-w-4xl mx-auto px-6 md:px-10"
    >
      <div className="text-xs uppercase tracking-widest text-[#D4F34A] mb-3">
        {eyebrow}
      </div>
      <h1
        data-testid={`${testId}-heading`}
        className="font-display uppercase tracking-tight text-5xl md:text-7xl leading-[0.9]"
      >
        {title}
      </h1>
      <div className="mt-4 text-[11px] uppercase tracking-widest text-neutral-500">
        Last updated · {lastUpdated}
      </div>
      {intro && (
        <p className="mt-8 text-neutral-300 text-base md:text-lg leading-relaxed max-w-3xl">
          {intro}
        </p>
      )}

      <div className="mt-12 space-y-12">
        {sections.map((s, i) => (
          <section
            key={s.title}
            data-testid={`${testId}-section-${i + 1}`}
            className="scroll-mt-32"
            id={s.id}
          >
            <div className="flex items-baseline gap-4 mb-4">
              <span className="font-display text-[#D4F34A] text-lg">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h2 className="font-display uppercase text-2xl md:text-3xl tracking-tight leading-tight">
                {s.title}
              </h2>
            </div>
            <div className="pl-0 md:pl-10 space-y-4 text-sm md:text-base text-neutral-300 leading-relaxed">
              {s.body.map((block, j) => {
                if (typeof block === "string") return <p key={j}>{block}</p>;
                if (block.type === "list") {
                  return (
                    <ul key={j} className="space-y-2 mt-2">
                      {block.items.map((item, k) => (
                        <li key={k} className="flex gap-3">
                          <span className="text-[#D4F34A] flex-none">·</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  );
                }
                if (block.type === "note") {
                  return (
                    <div
                      key={j}
                      className="border border-neutral-900 bg-neutral-950 p-4 text-sm text-neutral-400"
                    >
                      {block.text}
                    </div>
                  );
                }
                return null;
              })}
            </div>
          </section>
        ))}
      </div>
    </main>
  );
}
